import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { MenuItem, SelectField } from 'material-ui'

const selectorStyles = {
  boxShadow: 'none',
  padding: '0 2.5px',
  background: '#fff',
  fontSize: '12px',
  width: '100%',
}

export default class LocationSelector extends Component {
  constructor(props) {
    super(props)
  }
  static propTypes = {
    activeLocation: PropTypes.shape({
      active: PropTypes.bool.isRequired,
      additional_recipients: PropTypes.arrayOf(PropTypes.object),
      city: PropTypes.string,
      country_code: PropTypes.string,
      created_at: PropTypes.string,
      doctor_id: PropTypes.string,
      earliest_same_day_reminder_hour: PropTypes.number,
      facebook_url: PropTypes.string,
      forwarding_email: PropTypes.string,
      google_url: PropTypes.string,
      id: PropTypes.string,
      latitude: PropTypes.number,
      longitude: PropTypes.number,
      name: PropTypes.string,
      office_email: PropTypes.string,
      office_phone: PropTypes.string,
      phone_numbers: PropTypes.arrayOf(PropTypes.object),
      practice_id: PropTypes.number,
      state: PropTypes.string,
      street_address: PropTypes.string,
      timezone: PropTypes.string,
      updated_at: PropTypes.string,
      website: PropTypes.string,
      yelp_url: PropTypes.string,
      zip: PropTypes.string,
    }).isRequired,
    locations: PropTypes.arrayOf(
      PropTypes.shape({
        active: PropTypes.bool.isRequired,
        additional_recipients: PropTypes.arrayOf(PropTypes.object),
        city: PropTypes.string,
        country_code: PropTypes.string,
        created_at: PropTypes.string,
        doctor_id: PropTypes.string,
        earliest_same_day_reminder_hour: PropTypes.number,
        facebook_url: PropTypes.string,
        forwarding_email: PropTypes.string,
        google_url: PropTypes.string,
        id: PropTypes.string,
        latitude: PropTypes.number,
        longitude: PropTypes.number,
        name: PropTypes.string,
        office_email: PropTypes.string,
        office_phone: PropTypes.string,
        phone_numbers: PropTypes.arrayOf(PropTypes.object),
        practice_id: PropTypes.number,
        state: PropTypes.string,
        street_address: PropTypes.string,
        timezone: PropTypes.string,
        updated_at: PropTypes.string,
        website: PropTypes.string,
        yelp_url: PropTypes.string,
        zip: PropTypes.string,
      }).isRequired,
    ),
    onChange: PropTypes.func.isRequired,
  }

  render() {
    const { activeLocation, onChange, locations } = this.props
    return (
      <SelectField
        onChange={onChange}
        style={selectorStyles}
        underlineStyle={{ display: 'none' }}
        value={locations.find(loc => activeLocation.id === loc.id)}
      >
        {locations.map(loc => (
          <MenuItem value={loc} primaryText={loc.name} key={loc.id} />
        ))}
      </SelectField>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LeftMenu/LocationSelector.js